import React from 'react';
import c from 'classnames';
import { SearchkitWrapper } from '@uncinc/react-searchkit';

import type { SearchkitWrapperProps } from '@uncinc/react-searchkit/dist/components/Wrapper';

import { APP_OPTIONS, SEARCHKIT_HOST_URL } from '../../config/constants';
import {
  highlightAttributes,
  resultAttributes,
  searchAttributes,
  sorting,
} from '../SearchForumCategoryPosts/config';

// Subcomponents.
import Results from './Results';
import Pagination from './Pagination';

interface SearchForumFollowTopicSubcomponents {
  Results: typeof Results;
  Pagination: typeof Pagination;
}

export interface SearchForumFollowTopicProps extends Omit<SearchkitWrapperProps, 'connection' | 'indexName' | 'routing' | 'analytics' | 'searchSettings'> {
  uid?: number;
}

// eslint-disable-next-line max-len
const SearchForumFollowTopic: React.FC<SearchForumFollowTopicProps> & SearchForumFollowTopicSubcomponents = (props) => {
  const {
    uid,
    className,
    children,
    ...restProps
  } = props;

  const classNames = c('SearchForumFollowTopic', className);

  return (
    <SearchkitWrapper
      {...restProps}
      className={classNames}
      connection={{ host: SEARCHKIT_HOST_URL }}
      indexName={APP_OPTIONS.parameters.searchkitIndexForumThread}
      analytics={false}
      hitsPerPage={3}
      searchSettings={{
        search_attributes: searchAttributes,
        result_attributes: resultAttributes,
        highlight_attributes: highlightAttributes,
        sorting,
      }}
      requestOptions={{
        getBaseFilters: () => [
          {
            bool: {
              must: [
                {
                  terms: {
                    post_follow_uids: [uid],
                  },
                },
              ],
            },
          },
        ],
      }}
    >
      {children}
    </SearchkitWrapper>
  );
};

SearchForumFollowTopic.Results = Results;
SearchForumFollowTopic.Pagination = Pagination;

export default SearchForumFollowTopic;
